import { axiosInstance } from "src/config/axiosInstance";

const token = process.env.REACT_APP_TZ_API_KEY;

class ItineraryService {
    // static async updateTask(taskId, updateData) {
    //   try {
    //     const response = await axiosInstance.put(
    //       `/tasks/update/${taskId}`,
    //       updateData
    //     );
    //     return response.data;
    //   } catch (error) {
    //     console.error("An error occurred while updating the task:", error);
    //     throw error;
    //   }
    // }
    static async updateItineraryProducts(
        itineraryId,
        updateData,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/products/edit/${itineraryId}`,
                updateData,
                requestConfig,
            );
            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating the Itinerary:",
                error,
            );
            throw error;
        }
    }

    static async updateItineraryHotelSelected(
        itineraryId,
        updateData,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/hotelselected/edit/${itineraryId}`,
                updateData,
                requestConfig,
            );
            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating the Itinerary:",
                error,
            );
            throw error;
        }
    }

    static async updateItinerary(itineraryId, updateData, requestConfig = {}) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/edit/${itineraryId}`,
                updateData,
                requestConfig,
            );
            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating the Itinerary:",
                error,
            );
            throw error;
        }
    }

    static async isItineraryCreated(projectId, maxRetries, retryDelay) {
        let retries = 0;
        while (retries < maxRetries) {
            try {
                const response = await axiosInstance.get(
                    `/isProjectItineraryCreated/${projectId}`,
                    {
                        timeout: 10000,
                    },
                );

                return response;
            } catch (error) {
                console.error("Error fetching itinerary details:", error);
                retries++;
                await new Promise((resolve) => setTimeout(resolve, retryDelay));
            }
        }
    }

    static async setSelectedTicket(
        itineraryId,
        productCode,
        selectedTicket,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.post(
                `/itineraries/${itineraryId}/product/${productCode}/setSelectedTicket`,
                selectedTicket,
                requestConfig,
            );

            return response;
        } catch (error) {
            console.error("An error occurred:", error);
            throw error;
        }
    }

    static async setSelectedRoomRate(
        itineraryId,
        hotelCode,
        selectedRoom,
        selectedRate,
        requestConfig = {},
    ) {
        const data = {
            room: selectedRoom,
            roomRate: selectedRate,
        };
        try {
            const response = await axiosInstance.post(
                `/itineraries/${itineraryId}/hotel/${hotelCode}/setSelectedRoomRate`,
                data,
                requestConfig,
            );

            return response;
        } catch (error) {
            console.error("An error occurred:", error);
            throw error;
        }
    }

    static async updateProductManually(updateData) {
        try {
            const response = await axiosInstance.post(
                `/itineraries/updatePriceActivityManualItinerary`,
                updateData,
            );
            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating the Product:",
                error,
            );
            return { error: true };
        }
    }

    static async getItineraryFlightsOffers(projectId) {
        try {
            const response = await axiosInstance.get(
                `/flights/itineraryOffers/${projectId}`,
                {
                    timeout: 20000,
                },
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while fetching the flights offers:",
                error,
            );
            throw error;
        }
    }

    static async setNewSelectedFlight(
        projectId,
        itineraryId,
        oldFlightData,
        newFlightData,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/flights/edit/${itineraryId}`,
                {
                    oldFlightData,
                    newFlightData,
                    projectId,
                },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while setting the new selected flight:",
                error,
            );
            throw error;
        }
    }

    static async updateTransferFlightChange(
        itineraryId,
        itineraryIdWithFlights,
        updatedFlight,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/updateTransferFlightChange/${itineraryId}`,
                {
                    itineraryIdWithFlights,
                    updatedFlight,
                },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating the transfer flight change:",
                error,
            );
            throw error;
        }
    }

    static async deleteItineraryFlights(
        itineraryId,
        flightData,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/${itineraryId}/remove/flight`,
                flightData,
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while deleting the itinerary flights:",
                error,
            );
            throw error;
        }
    }

    static async addManualFlight(itineraryId, flightData, requestConfig = {}) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/${itineraryId}/add/manual/flight`,
                { flightData },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while adding the manual flight:",
                error,
            );
            throw error;
        }
    }

    static async updateManualFlight(
        itineraryId,
        flightData,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/${itineraryId}/update/flight`,
                { ...flightData },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating the manual flight:",
                error,
            );
            console.log(error);
        }
    }

    static async updateOptionalsHotels(
        itineraryId,
        hotelCode,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `itineraries/${itineraryId}/update/optionalHotel`,
                { hotelCode },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating the optionals hotels:",
                error,
            );
            throw error;
        }
    }

    static async addItineraryAttraction(
        itineraryId,
        attractionData,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/${itineraryId}/add/attraction`,
                { attractionData },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while adding the itinerary attraction:",
                error,
            );
            throw error;
        }
    }

    static async removeProductItinerary(
        itineraryId,
        _id,
        slot,
        productCode,
        day,
        requestConfig = {},
    ) {
        try {
            await axiosInstance.delete(
                `${process.env.REACT_APP_HOST_API}/itineraries/${itineraryId}/remove/product/${_id}/${slot}/${productCode}/${day}`,
                requestConfig,
            );
        } catch (error) {
            console.error(
                "An error occurred while deleting activity:",
                error?.message,
            );
            throw error;
        }
    }

    static async addProductToItinerary(
        itineraryId,
        productData,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.post(
                `itineraries/${itineraryId}/add/day/${productData?.day}/${
                    productData?.timeframe || productData?.slot
                }/product/${productData?.productCode}/${productData?.lang}`,
                productData,
                requestConfig,
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async removeTransfersFromItinerary(
        itineraryId,
        transferRateKey,
        requestConfig = {},
    ) {
        try {
            await axiosInstance.delete(
                `${process.env.REACT_APP_HOST_API}/itineraries/${itineraryId}/remove/transfer/${transferRateKey}`,
                requestConfig,
            );
        } catch (error) {
            console.error(
                "An error occurred while deleting transfer:",
                error?.message,
            );
            throw error;
        }
    }

    static async setHotelSelectedItinerary(
        itineraryId,
        hotelToAdd,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.post(
                `/itineraries/${itineraryId}/add/hotel`,
                {
                    hotelSelected: hotelToAdd,
                },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async setMainHotel(itineraryId, hotelToAdd, requestConfig = {}) {
        try {
            await axiosInstance.get(
                `/itineraries/${itineraryId}/hotel/setMainHotel/${hotelToAdd.code}`,
                requestConfig,
            );
        } catch (error) {
            throw error;
        }
    }

    static async DeleteHotel(itineraryId, index, requestConfig = {}) {
        try {
            const response = await axiosInstance.post(
                `/itineraries/${itineraryId}/remove/hotel/${index}`,
                undefined,
                requestConfig,
            );

            return response;
        } catch (error) {
            throw error;
        }
    }

    static async updateHotel(itineraryId, hotelToUpdate, requestConfig = {}) {
        try {
            await axiosInstance.put(
                `/itineraries/edit/${itineraryId}/hotels`,
                {
                    hotelToUpdate,
                },
                requestConfig,
            );
        } catch (error) {
            throw error;
        }
    }

    static async updateItineraryProductDB(
        itineraryId,
        day,
        slot,
        product,
        lang,
        requestConfig = {},
    ) {
        try {
            await axiosInstance.post(
                `${process.env.REACT_APP_HOST_API}/itineraries/${itineraryId}/add/day/${day}/${slot}/product/${product.productCode}/${lang}`,
                { productSelected: JSON.stringify(product) },
                requestConfig,
            );
        } catch (error) {
            throw error;
        }
    }

    static async updateItineraryManualTransfer(
        itineraryId,
        transferData,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/${itineraryId}/update/transfer`,
                transferData,
                requestConfig,
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async AddManualTransfer(
        itineraryId,
        transferData,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.post(
                `/itineraries/${itineraryId}/add/manual/transfer`,
                transferData,
                requestConfig,
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async setItineraryProducts(itineraryId, body, requestConfig = {}) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/set/products/${itineraryId}`,
                body,
                requestConfig,
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async UpdateManualProductsFromText(
        itineraryId,
        data,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/${itineraryId}/update/text/products`,
                data,
                requestConfig,
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async updateDbItineraryDailyImages(
        itineraryId,
        day,
        image,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/daily/images/${itineraryId}`,
                { imageUrl: image, day },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async updateHotelItineraryDb(
        itineraryId,
        hotelCode,
        data,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/${itineraryId}/update/hotel`,
                {
                    ...data,
                    code: hotelCode,
                },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async updateOptionalProducts(
        itineraryId,
        productId,
        type,
        viewType,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/${itineraryId}/update/optional/products`,
                { productId, type, viewType },
                {
                    ...requestConfig,
                    headers: {
                        ...(viewType === "customer" && {
                            "tz-api-key": token,
                        }),
                        ...requestConfig.headers,
                    },
                },
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async updateItineraryDaysDb(data, requestConfig = {}) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/update/days`,
                data,
                requestConfig,
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async updateFlightsItinerary(
        projectId,
        flights,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/update/flights/${projectId}`,
                {
                    flights,
                },
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    static async toggleShowHotelInEvening(itineraryId, requestConfig = {}) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/${itineraryId}/toggle/showHotelInEvening`,
                undefined,
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while toggling showHotelInEvening:",
                error,
            );
            throw error;
        }
    }

    static async updateWhatsIncluded(projectId, data, requestConfig = {}) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/whatsIncluded/${projectId}`,
                data,
                requestConfig,
            );

            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating whats included:",
                error,
            );
            throw error;
        }
    }

    static async updateDailyStories(
        itineraryId,
        dailyStories,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/dailyStories/edit/${itineraryId}`,
                { dailyStories },
                requestConfig,
            );
            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating daily stories:",
                error,
            );
            throw error;
        }
    }

    static async updateDailyTitles(
        itineraryId,
        dailyTitles,
        requestConfig = {},
    ) {
        try {
            const response = await axiosInstance.put(
                `/itineraries/dailyTitles/edit/${itineraryId}`,
                { dailyTitles },
                requestConfig,
            );
            return response.data;
        } catch (error) {
            console.error(
                "An error occurred while updating daily titles:",
                error,
            );
            throw error;
        }
    }
}

export default ItineraryService;
